import { Box, Flex, Grid, GridItem, Icon, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { FaRegArrowAltCircleRight } from 'react-icons/fa'
import { formatPrice } from '../../../../../../utils/formatPrice'

export function Item({ item, itemSelected, handleSelectItem }) {
    const [hovered, setHovered] = useState(false)
    return (
        <Grid
            gridTemplateColumns="1fr 90px 90px 160px 60px"
            placeItems="center"
            onClick={() => handleSelectItem(item)}
            py="14px"
            bgColor={'#F5F5F5'}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            _hover={{
                bgColor: '#378BBF',
                cursor: 'pointer',
                color: 'white!important',
            }}
            position="relative"
            //define a cor do svg
            sx={{
                '&:hover svg': {
                    color: 'white',
                },

                svg: {
                    color: !itemSelected && '#378BBF',
                },
            }}
            {...(itemSelected && {
                bgColor: '#378BBF',
                color: 'white',
            })}
        >
            {item?.flag && (
                <Box position="absolute" top="-18px" left="0" px={2} bg="#378BBF" color="white" fontSize="12px" textTransform="uppercase">
                    {item.flag}
                </Box>
            )}
            {item?.gratis && (
                <Box
                    position="absolute"
                    top="0"
                    left="0"
                    px={2}
                    bg={'#378BBF'}
                    color="white"
                    {...((hovered || itemSelected) && { bg: 'white', color: '#378BBF' })}
                    fontSize="12px"
                    textTransform="uppercase"
                >
                    GRÁTIS
                </Box>
            )}

            <GridItem ml="18px" placeSelf="start" display="flex" alignItems="center" justifyContent="space-between" w="100%">
                {item.nome_transportadora}

                {item?.taxas && (
                    <Box
                        mr="8"
                        px={2}
                        bg="transparent"
                        border="1px solid #FF0000"
                        color="#FF0000"
                        fontSize="12px"
                        textTransform="uppercase"
                        borderRadius="8px"
                        {...(hovered && { bg: '#FF0000', color: 'white' })}
                    >
                        VER TAXAS
                        <Box
                            position="absolute"
                            top="100%"
                            left="50%"
                            transform="translate(-50%, 0)"
                            color="white"
                            fontSize="12px"
                            textTransform="uppercase"
                            borderRadius="8px"
                            display="none"
                            zIndex="999"
                            {...(hovered && { display: 'block' })}
                        >
                            {item?.taxas && <Taxas taxas={item.taxas} />}
                        </Box>
                    </Box>
                )}
            </GridItem>
            <GridItem>{item.prazo_entrega} dias úteis</GridItem>
            <GridItem>
                <Box />
            </GridItem>
            <GridItem>
                <strong>{item.valor_total_frete_30}</strong>
            </GridItem>
            <GridItem display="flex" justifyContent="center" alignItems="center">
                <Icon as={FaRegArrowAltCircleRight} fontSize="20px" {...((itemSelected || hovered) && { color: 'white' })} />
            </GridItem>
        </Grid>
    )
}

// const taxas = {
//   "fretepeso": "76.65",
//   "gris": "27.75",
//   "tde": "49.43",
//   "agendamentodeentrega": "40.93"
// };

export function Taxas({ taxas }) {
    if (!taxas)
        return (
            <Flex w="100%" justifyContent="space-between">
                <Text>Não há taxas</Text>
            </Flex>
        )

    const taxasEntries = Object.entries(taxas) // [['taxa1', 10], ['taxa2', 20]]

    return taxasEntries.map(([taxa, valor]) => (
        <Flex w="250px" justifyContent="space-between" bgColor="gray.100" color="black" p={2} borderRadius="8px" border="1px solid" borderColor="gray.200" boxShadow="md">
            <Text>{taxa}</Text>
            <Text>{formatPrice(valor)}</Text>
        </Flex>
    ))
}
